module.exports = __webpack_public_path__ + "img/intj.84bcd246.png";